import {createRouter, createWebHistory} from 'vue-router';
import store from "@/store";
import Home from '../views/Home.vue';
import Login from "../views/Login";

const routes = [
    {
        path: '/dashboard',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            requiresUnauth: true
        }
    },

    {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/',
        name: 'Schedule',
        component: () => import('@/views/Schedule'),
        meta: {
            requiresAuth: true
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(function (to, _, next) {
    if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
        next({
            path: '/login',
            query: {
                nextUrl: to.fullPath
            }
        });
    } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
        next('/');
    } else {
        next();
    }
});

export default router
